export const ADD_INGREDIENT = 'ADD_INGREDIENT';
export const REMOVE_INGREDIENT = 'REMOVE_INGREDIENT';
export const SET_INGREDIENTS = 'SET_INGREDIENTS';
export const FETCH_INGREDIENTS_FAILED = 'FETCH_INGREDIENTS_FAILED';

export const PURCHASE_BURGER_START = 'PURCHASE_BURGER_START';
export const PURCHASE_BURGER_SUCCESS = 'PURCHASE_BURGER_SUCCESS';
export const PURCHASE_BURGER_FAIL = 'PURCHASE_BURGER_FAIL';
export const PURCHASE_INIT = 'PURCHASE_INIT';

export const FETCH_ORDERS_START = 'FETCH_ORDERS_START';
export const FETCH_ORDERS_SUCCESS = 'FETCH_ORDERS_SUCCESS';
export const FETCH_ORDERS_FAIL = 'FETCH_ORDERS_FAIL';

export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_SUCCESS_GAME = 'AUTH_SUCCESS_GAME';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_LOGOUT_SUCCESS = 'AUTH_LOGOUT_SUCCESS';
export const INIT_SUCCESS = 'INIT_SUCCESS';

export const SET_AUTH_REDIRECT_PATH = 'SET_AUTH_REDIRECT_PATH';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';

// export const USER_UPLOAD_IMAGE = 'USER_UPLOAD_IMAGE';
export const USER_UPDATE_SUCCESS = 'USER_UPDATE_SUCCESS';
export const USER_UPDATE_FAIL = 'USER_UPDATE_FAIL';
export const USER_UPDATE_START = 'USER_UPDATE_START';
export const USER_GAME_ENTER_SUCCESS = 'USER_GAME_ENTER_SUCCESS';

export const GAME_CREATE = 'GAME_CREATE';
export const GAME_CREATE_SUCCESS = 'GAME_CREATE_SUCCESS';
export const GAME_EXIT_SUCCESS = 'GAME_EXIT_SUCCESS';
export const GAME_CHECK_STATUS_SUCCESS = 'GAME_CHECK_STATUS_SUCCESS';
export const GAME_CHECK_PLAYER_STATUS_SUCCESS = 'GAME_CHECK_PLAYER_STATUS_SUCCESS';
export const GAME_CREATE_FAIL = 'GAME_CREATE_SUCCESS';
export const GAME_START_SUCCESS = 'GAME_START_SUCCESS';
export const GAME_SET_QUESTION_SUCCESS = 'GAME_SET_QUESTION_SUCCESS';
export const GAME_SET_PRESET_OPTIONS_SUCCESS = 'GAME_SET_PRESET_OPTIONS_SUCCESS';
export const GAME_INPUT_SUBMIT_SUCCESS = 'GAME_INPUT_SUBMIT_SUCCESS';
export const GAME_MOVE_FORWARD_SUCCESS = 'GAME_MOVE_FORWARD_SUCCESS';
export const GAME_MOVE_TO_LAST_STAGE_SUCCESS = 'GAME_MOVE_TO_LAST_STAGE_SUCCESS';
export const GAME_MOVE_TO_NEXT_QUESTION_SUCCESS = 'GAME_MOVE_TO_NEXT_QUESTION_SUCCESS';
export const GAME_GET_INFO_SUCCESS = 'GAME_GET_INFO_SUCCESS';
export const GAME_CHECK_USER_GAMING_STATUS_SUCCESS = "GAME_CHECK_USER_GAMING_STATUS_SUCCESS";
export const GAME_JOIN_SUCCESS = 'GAME_JOIN_SUCCESS';
export const GAME_SUBMIT_MESSAGE_SUCCESS = 'GAME_SUBMIT_MESSAGE_SUCCESS';
export const GAME_SET_MESSAGES_SUCCESS = 'GAME_SET_MESSAGES_SUCCESS';
export const GAME_SET_UMESSAGES_SUCCESS = 'GAME_SET_UMESSAGES_SUCCESS';
export const GAME_HAS_ANIMATED = 'GAME_HAS_ANIMATED';
export const GAME_WILL_ANIMATE = 'GAME_WILL_ANIMATE';
export const GAME_JUDGE_SUCCESS = 'GAME_JUDGE_SUCCESS';
// export const GAME_GET_PLAYER_RANKING_SUCCESS = 'GAME_GET_PLAYER_RANKING_SUCCESS';

export const SET_GAME_REDIRECT_PATH = 'GAME_CREATE_SUCCESS';
export const GAME_PLAYER_IS_READY = 'GAME_PLAYER_IS_READY';



// WEBPACK FOOTER //
// ./src/store/actions/actionTypes.js